import { Entite } from './../classes/entite';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '../../core/services/api.service';
import { ApiResponse } from '../../core/shared/classes/api';


@Injectable()
export class Z16ProEntiteService {

    constructor (
        private apiService: ApiService
    ) { }

    getEntitesSchema() {
        return this.apiService.get(`z16pro/entites/schema`);
    }

    getEntitesByLocale(locale: string) {
        return this.apiService.get(`z16pro/entites/locale/${locale}`);
    }

    updateEntitesByLocale(locale: string, data: Entite[] = []) {
        return this.apiService.post(`z16pro/entites/locale/${locale}`, {entites: data});
    }

    getEntitesByCode(entiteCode: string) {
        return this.apiService.get(`z16pro/entites/code/${entiteCode}`);
    }

    getLayoutByEntite(entiteCode: string) {
        return this.apiService.get(`z16pro/layout/${entiteCode}`);
    }

    getLayoutWithDonneesByEntite(entiteCode: string, entiteId: string) {
        return this.apiService.get(`z16pro/layout/${entiteCode}/${entiteId}`);
    }

    getEntiteDonnees(entiteCode: string, entiteId: string) {
        return this.apiService.get(`z16pro/donnees/${entiteCode}/${entiteId}`);
    }

}
